import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/data";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="py-24 sm:py-32 relative" data-testid="about-section">
      <div className="container-x grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="relative">
          <Reveal>
            <div className="relative overflow-hidden rounded-2xl border border-white/10">
              <img
                src={IMAGES.aboutInterior}
                alt="Renovated modern interior"
                className="w-full h-[420px] sm:h-[520px] object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="absolute -bottom-8 -right-4 sm:right-8 w-40 sm:w-52 rounded-2xl overflow-hidden border border-white/15 shadow-2xl hidden sm:block"
          >
            <img src={IMAGES.kitchen} alt="Kitchen renovation" className="w-full h-40 object-cover" loading="lazy" />
          </motion.div>
          <div className="absolute -top-6 -left-3 sm:-left-6 glass rounded-2xl px-6 py-4">
            <div className="font-display font-extrabold text-3xl text-[#FF8C42]">850+</div>
            <div className="text-xs text-[#9CA3AF] mt-0.5">projects · проектов</div>
          </div>
        </div>

        <div>
          <Reveal><span className="tag-label">{t.about.tag}</span></Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl mt-5 leading-[1.03]">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="text-[#C7CCD6] text-base sm:text-lg mt-6 leading-relaxed">{t.about.p1}</p>
          </Reveal>
          <Reveal delay={0.22}>
            <p className="text-[#9CA3AF] mt-4 leading-relaxed">{t.about.p2}</p>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-4 mt-9">
            {t.about.points.map((p, i) => (
              <Reveal key={i} delay={0.28 + i * 0.06}>
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 grid place-items-center h-6 w-6 rounded-full bg-[#E85D04]/15 text-[#FF8C42] shrink-0">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  <span className="text-[#E5E7EB] font-medium">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
